var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      class: { "grid-list-md": _vm.isMobile, "grid-list-lg": !_vm.isMobile },
      attrs: { "px-0": "" }
    },
    [
      _c(
        "v-form",
        { ref: "serviceInformation" },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md6: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Provider", readonly: "" },
                    model: {
                      value: _vm.providerNameCheck,
                      callback: function($$v) {
                        _vm.providerNameCheck = $$v
                      },
                      expression: "providerNameCheck"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md6: "" } },
                [
                  _c(
                    "v-text-field",
                    {
                      attrs: { placeholder: "—", readonly: "" },
                      model: {
                        value:
                          _vm.student.form.serviceInformation.credentialName,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.student.form.serviceInformation,
                            "credentialName",
                            $$v
                          )
                        },
                        expression:
                          "student.form.serviceInformation.credentialName"
                      }
                    },
                    [
                      _c("template", { slot: "label" }, [
                        _vm.isMobile
                          ? _c("span", [_vm._v("Credentials")])
                          : _c("span", [_vm._v("Provider Credentials")])
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  class: {
                    "xs12 sm6 md6": _vm.providerAbsent,
                    "xs12 sm4 md4": !_vm.hideFields || _vm.studentAbsent
                  }
                },
                [
                  _c(
                    "v-menu",
                    {
                      ref: "serviceMenu",
                      attrs: {
                        "close-on-content-click": true,
                        "nudge-right": 40,
                        "return-value": _vm.serviceDate,
                        lazy: "",
                        transition: "scale-transition",
                        "offset-y": "",
                        "full-width": "",
                        "max-width": "290px",
                        "min-width": "290px"
                      },
                      on: {
                        "update:returnValue": function($event) {
                          _vm.serviceDate = $event
                        },
                        "update:return-value": function($event) {
                          _vm.serviceDate = $event
                        }
                      },
                      model: {
                        value: _vm.serviceMenu,
                        callback: function($$v) {
                          _vm.serviceMenu = $$v
                        },
                        expression: "serviceMenu"
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          slot: "activator",
                          "error-messages": _vm.sessionDateErrors,
                          label: "Service Date",
                          placeholder: "Select a Service Date",
                          readonly: ""
                        },
                        slot: "activator",
                        model: {
                          value:
                            _vm.student.form.serviceInformation.sessionDate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "sessionDate",
                              $$v
                            )
                          },
                          expression:
                            "student.form.serviceInformation.sessionDate"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-date-picker", {
                        attrs: {
                          allowedDates: _vm.allowedDates,
                          "no-title": "",
                          scrollable: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.serviceDateChanged(_vm.serviceDate)
                          },
                          input: function($event) {
                            return _vm.$refs.serviceMenu.save(_vm.serviceDate)
                          }
                        },
                        model: {
                          value: _vm.serviceDate,
                          callback: function($$v) {
                            _vm.serviceDate = $$v
                          },
                          expression: "serviceDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.hideFields
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.filterServiceDeliveredArray,
                          "error-messages": _vm.serviceDeliveredErrors,
                          "item-text": "name",
                          "item-value": "value",
                          label: "Service Delivered",
                          placeholder: "Select Service Delivered"
                        },
                        on: {
                          change: _vm.serviceDeliveredChanged,
                          blur: function($event) {
                            return _vm.v.serviceDelivered.$touch()
                          }
                        },
                        model: {
                          value:
                            _vm.student.form.serviceInformation
                              .serviceDelivered,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "serviceDelivered",
                              $$v
                            )
                          },
                          expression:
                            "student.form.serviceInformation.serviceDelivered"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isConsultationService
                ? _c(
                    "v-flex",
                    {
                      class: {
                        "xs12 sm6 md6": _vm.providerAbsent,
                        "xs12 sm4 md4": !_vm.hideFields || _vm.studentAbsent
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.absentTypesArray,
                          "error-messages": _vm.absentTypeErrors,
                          "item-text": "name",
                          "item-value": "value",
                          label: "Student/Provider Not Available",
                          placeholder: "Select Student or Provider",
                          clearable: ""
                        },
                        on: {
                          change: _vm.absentTypeChanged,
                          blur: function($event) {
                            return _vm.v.absentType.$touch()
                          }
                        },
                        model: {
                          value: _vm.student.form.serviceInformation.absentType,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "absentType",
                              $$v
                            )
                          },
                          expression:
                            "student.form.serviceInformation.absentType"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.studentAbsent
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.absentReasonsArray,
                          "item-text": "name",
                          "item-value": "value",
                          label: "Reason Student Not Available",
                          placeholder: "Select Why Student is Not Available",
                          "error-messages": _vm.absentReasonErrors
                        },
                        on: {
                          blur: function($event) {
                            return _vm.v.absentReason.$touch()
                          }
                        },
                        model: {
                          value:
                            _vm.student.form.serviceInformation.absentReason,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "absentReason",
                              $$v
                            )
                          },
                          expression:
                            "student.form.serviceInformation.absentReason"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.providerAbsent
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md6: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.absentAlternativesArray,
                          "item-text": "name",
                          "item-value": "value",
                          label: "Service Alternative",
                          placeholder: "Select Service Alternative",
                          "error-messages": _vm.absentAltErrors
                        },
                        on: {
                          blur: function($event) {
                            return _vm.v.absentAlternative.$touch()
                          }
                        },
                        model: {
                          value:
                            _vm.student.form.serviceInformation
                              .absentAlternative,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "absentAlternative",
                              $$v
                            )
                          },
                          expression:
                            "student.form.serviceInformation.absentAlternative"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.providerAbsent && _vm.notAltService
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md6: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.noServiceProvidedOptions,
                          "item-text": "name",
                          "item-value": "value",
                          label: "Parents Informed?",
                          placeholder: "Select Yes or No",
                          "error-messages": _vm.noServiceNotifErrors
                        },
                        on: {
                          blur: function($event) {
                            return _vm.v.noServiceNotifFlag.$touch()
                          }
                        },
                        model: {
                          value:
                            _vm.student.form.serviceInformation
                              .noServiceNotifFlag,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "noServiceNotifFlag",
                              $$v
                            )
                          },
                          expression:
                            "student.form.serviceInformation.noServiceNotifFlag"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.providerAbsent && _vm.altService
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Alternate Description",
                          placeholder: "Enter Alternate Description",
                          counter: "",
                          maxlength: "30",
                          "error-messages": _vm.absentAltDescErrors
                        },
                        on: {
                          blur: function($event) {
                            return _vm.handleTextTrimmingRequiredField(
                              "absentAlternativeDesc",
                              _vm.student.form.serviceInformation
                                .absentAlternativeDesc
                            )
                          }
                        },
                        model: {
                          value:
                            _vm.student.form.serviceInformation
                              .absentAlternativeDesc,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "absentAlternativeDesc",
                              $$v
                            )
                          },
                          expression:
                            "student.form.serviceInformation.absentAlternativeDesc"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              !_vm.hideFields
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c(
                        "v-text-field",
                        {
                          attrs: {
                            "error-messages": _vm.sessionTimeErrors,
                            label: "Start Time",
                            type: "time"
                          },
                          on: { blur: _vm.startTimeChanged },
                          model: {
                            value:
                              _vm.student.form.serviceInformation.sessionTime,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.student.form.serviceInformation,
                                "sessionTime",
                                $$v
                              )
                            },
                            expression:
                              "student.form.serviceInformation.sessionTime"
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "prepend" },
                            [
                              _c(
                                "v-dialog",
                                {
                                  ref: "startTimeDialog",
                                  attrs: {
                                    lazy: "",
                                    "full-width": "",
                                    width: "290px"
                                  },
                                  model: {
                                    value: _vm.startTimeModal,
                                    callback: function($$v) {
                                      _vm.startTimeModal = $$v
                                    },
                                    expression: "startTimeModal"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [_vm._v("access_time")]
                                  ),
                                  _vm._v(" "),
                                  _vm.startTimeModal
                                    ? _c(
                                        "v-time-picker",
                                        {
                                          attrs: { "full-width": "" },
                                          model: {
                                            value:
                                              _vm.student.form
                                                .serviceInformation.sessionTime,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.student.form
                                                  .serviceInformation,
                                                "sessionTime",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "student.form.serviceInformation.sessionTime"
                                          }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                flat: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.startTimeModal = false
                                                }
                                              }
                                            },
                                            [_vm._v("Cancel")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                flat: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: _vm.startTimeChanged
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  OK\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideFields
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c(
                        "v-text-field",
                        {
                          attrs: {
                            "error-messages": _vm.sessionTimeEndErrors,
                            label: "End Time",
                            type: "time"
                          },
                          on: { blur: _vm.endTimeChanged },
                          model: {
                            value:
                              _vm.student.form.serviceInformation
                                .sessionTimeEnd,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.student.form.serviceInformation,
                                "sessionTimeEnd",
                                $$v
                              )
                            },
                            expression:
                              "student.form.serviceInformation.sessionTimeEnd"
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "prepend" },
                            [
                              _c(
                                "v-dialog",
                                {
                                  ref: "endTimeDialog",
                                  attrs: {
                                    lazy: "",
                                    "full-width": "",
                                    width: "290px"
                                  },
                                  model: {
                                    value: _vm.endTimeModal,
                                    callback: function($$v) {
                                      _vm.endTimeModal = $$v
                                    },
                                    expression: "endTimeModal"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [_vm._v("access_time")]
                                  ),
                                  _vm._v(" "),
                                  _vm.endTimeModal
                                    ? _c(
                                        "v-time-picker",
                                        {
                                          attrs: { "full-width": "" },
                                          model: {
                                            value:
                                              _vm.student.form
                                                .serviceInformation
                                                .sessionTimeEnd,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.student.form
                                                  .serviceInformation,
                                                "sessionTimeEnd",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "student.form.serviceInformation.sessionTimeEnd"
                                          }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                flat: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.endTimeModal = false
                                                }
                                              }
                                            },
                                            [_vm._v("Cancel")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                flat: "",
                                                color: "primary"
                                              },
                                              on: { click: _vm.endTimeChanged }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  OK\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideFields
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Service Length (mins)",
                          placeholder: "Enter Service Length",
                          "error-messages": _vm.serviceLengthErrors,
                          type: "number",
                          required: ""
                        },
                        on: { blur: _vm.sessionMinutesChanged },
                        model: {
                          value:
                            _vm.student.form.serviceInformation.sessionMinutes,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "sessionMinutes",
                              $$v
                            )
                          },
                          expression:
                            "student.form.serviceInformation.sessionMinutes"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  class: {
                    "xs12 sm6 md3": !_vm.hideFields && _vm.showGroup,
                    "xs12 sm6 md6": _vm.hideFields && _vm.showGroup,
                    "xs12 sm4 md4": !_vm.hideFields && !_vm.showGroup,
                    "xs12 sm4 md4": _vm.hideFields && !_vm.showGroup
                  }
                },
                [
                  _c(
                    "v-combobox",
                    {
                      attrs: {
                        dense: "",
                        label: "Location",
                        placeholder: "Enter Location",
                        items: _vm.locationsArray,
                        loading: _vm.locationsLoading,
                        clearable: true,
                        "item-text": "locationName",
                        "return-object": true,
                        "search-input": _vm.searchInput,
                        "error-messages": _vm.locationErrors,
                        "no-filter": true
                      },
                      on: {
                        "update:searchInput": function($event) {
                          _vm.searchInput = $event
                        },
                        "update:search-input": function($event) {
                          _vm.searchInput = $event
                        },
                        blur: function($event) {
                          return _vm.v.location.$touch()
                        },
                        change: function($event) {
                          return _vm.v.location.$touch()
                        },
                        focus: _vm.clearLocationsAutoComplete
                      },
                      model: {
                        value: _vm.student.form.serviceInformation.location,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.student.form.serviceInformation,
                            "location",
                            $$v
                          )
                        },
                        expression: "student.form.serviceInformation.location"
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "no-data" },
                        [
                          _c(
                            "v-list",
                            [
                              !_vm.searchInput
                                ? _c("v-list-tile", [
                                    _vm._v(
                                      "\n                Please type a Location.\n              "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.searchInput && !_vm.locationsLoading
                                ? _c("v-list-tile", [
                                    _vm._v(
                                      "\n                No Results\n              "
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  class: {
                    "xs12 sm6 md3": !_vm.hideFields && _vm.showGroup,
                    "xs12 sm6 md6": _vm.hideFields && _vm.showGroup,
                    "xs12 sm4 md4": !_vm.hideFields && !_vm.showGroup,
                    "xs12 sm4 md4": _vm.hideFields && !_vm.showGroup
                  }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Location Details",
                      placeholder: "Enter Location Details",
                      counter: "",
                      maxlength: "30"
                    },
                    on: {
                      blur: function($event) {
                        return _vm.handleTextTrimming(
                          "locationOther",
                          _vm.student.form.serviceInformation.locationOther
                        )
                      }
                    },
                    model: {
                      value: _vm.student.form.serviceInformation.locationOther,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.student.form.serviceInformation,
                          "locationOther",
                          $$v
                        )
                      },
                      expression:
                        "student.form.serviceInformation.locationOther"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              !_vm.hideFields && _vm.showGroup
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md3: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.groupTypeArray,
                          "item-text": "name",
                          "item-value": "value",
                          label: "Group Type",
                          placeholder: "Select Group Type"
                        },
                        on: { change: _vm.groupTypeChanged },
                        model: {
                          value: _vm.student.form.serviceInformation.groupType,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "groupType",
                              $$v
                            )
                          },
                          expression:
                            "student.form.serviceInformation.groupType"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideFields && !_vm.isConsultationService
                ? _c(
                    "v-flex",
                    {
                      class: {
                        "xs12 sm6 md3": _vm.showGroup,
                        "xs12 sm6 md4": !_vm.showGroup
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Group Size",
                          placeholder: "Enter Group Size",
                          "error-messages": _vm.groupSizeErrors,
                          type: "number",
                          required: ""
                        },
                        on: {
                          blur: function($event) {
                            return _vm.v.groupSize.$touch()
                          }
                        },
                        model: {
                          value: _vm.student.form.serviceInformation.groupSize,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "groupSize",
                              $$v
                            )
                          },
                          expression:
                            "student.form.serviceInformation.groupSize"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              !_vm.hideFields
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md5: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.filterDisabledOptions(
                            _vm.deliveryModeArray,
                            _vm.student.form.serviceInformation.deliveryMode
                          ),
                          "error-messages": _vm.deliveryModeErrors,
                          "item-text": "name",
                          "item-value": "value",
                          label: "Delivery Mode",
                          placeholder: "Select Delivery Mode"
                        },
                        on: {
                          blur: function($event) {
                            return _vm.v.deliveryMode.$touch()
                          }
                        },
                        model: {
                          value:
                            _vm.student.form.serviceInformation.deliveryMode,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "deliveryMode",
                              $$v
                            )
                          },
                          expression:
                            "student.form.serviceInformation.deliveryMode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideFields && !_vm.hideRoomField
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md5: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Classroom Number",
                          placeholder: "Enter Classroom Number",
                          counter: "",
                          maxlength: "30"
                        },
                        on: {
                          blur: function($event) {
                            return _vm.handleTextTrimming(
                              "roomName",
                              _vm.student.form.serviceInformation.roomName
                            )
                          }
                        },
                        model: {
                          value: _vm.student.form.serviceInformation.roomName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "roomName",
                              $$v
                            )
                          },
                          expression: "student.form.serviceInformation.roomName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideFields && !_vm.hideProviderLocationField
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md5: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Provider Location",
                          placeholder: "Enter Provider Location",
                          counter: "",
                          maxlength: "30",
                          "error-messages": _vm.providerLocationErrors
                        },
                        on: {
                          blur: function($event) {
                            return _vm.handleTextTrimmingRequiredField(
                              "providerLocation",
                              _vm.student.form.serviceInformation
                                .providerLocation
                            )
                          }
                        },
                        model: {
                          value:
                            _vm.student.form.serviceInformation
                              .providerLocation,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.student.form.serviceInformation,
                              "providerLocation",
                              $$v
                            )
                          },
                          expression:
                            "student.form.serviceInformation.providerLocation"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("v-textarea", {
            attrs: {
              label: "Comments",
              placeholder: "Enter Comments",
              counter: "",
              maxlength: "155",
              "error-messages": _vm.notesErrors
            },
            on: {
              blur: function($event) {
                return _vm.handleTextTrimming(
                  "notes",
                  _vm.student.form.serviceInformation.notes
                )
              }
            },
            model: {
              value: _vm.student.form.serviceInformation.notes,
              callback: function($$v) {
                _vm.$set(_vm.student.form.serviceInformation, "notes", $$v)
              },
              expression: "student.form.serviceInformation.notes"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-245a5248", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-245a5248","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/service-information.vue
// module id = null
// module chunks = 